import Model from './Model'

export default class VideoEngagement extends Model
{
    resource()
    {
        return 'engagement'
    }
}
